import { Grid, MenuItem, Typography } from '@material-ui/core'
import { Field } from 'redux-form'
import {
  ReduxDatePicker,
  ReduxFormField
} from '../../../components/FormInput/ReduxWrappers'
import i18n from '../../../translations/i18n'
import {
  validateEmail,
  noSpacesPhoneNum,
  required,
  stripSpaces
} from '../../../utils/validation/forms'
import {
  creditStatus,
  depositPaymentMethod,
  language,
  lifeSituation,
  movingWith,
  pets,
  status
} from '../data/applicationProperties'

const ApplicationFormFields = ({ t }: { t: i18n.TFunction }) => (
  <Grid container spacing={1}>
    <Grid item sm={12}>
      <Typography variant='h4' gutterBottom>
        {t('general.edit')}
      </Typography>
    </Grid>
    <Grid item xs={12} sm={12}>
      <ReduxFormField
        name='application.data.name'
        type='text'
        label={t('application.list.name')}
        required
        validate={[required]} // Add proper validation later
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <Field
        fullWidth
        name='application.data.birthdate'
        label={t('application.list.birthdate')}
        required
        validate={[required]}
        component={ReduxDatePicker}
        inputVariant='outlined'
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.email'
        type='text'
        label={t('application.list.email')}
        required
        validate={[required, validateEmail]}
        normalize={stripSpaces}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.phone'
        type='number'
        label={t('application.list.phone')}
        required
        validate={[required, noSpacesPhoneNum]}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.language'
        label={t('application.list.language')}
        select
        required
        validate={[required]}
      >
        {language.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.movingWith'
        label={t('application.list.movingWith')}
        select
        required
        validate={[required]}
      >
        {movingWith.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.movingWithAmount'
        type='text'
        label={t('application.list.movingWithAmount')}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.movingWithDescription'
        type='text'
        label={t('application.list.movingWithDescription')}
        multiline={true}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.lifeSituation'
        label={t('application.list.lifeSituation')}
        select
        required
        validate={[required]}
      >
        {lifeSituation.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.pets'
        label={t('application.list.pets')}
        select
        required
      >
        {pets.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.petType'
        type='text'
        multiline={true}
        label={t('application.list.petType')}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.depositPaymentMethod'
        label={t('application.list.depositPaymentMethod')}
        select
        required
      >
        {depositPaymentMethod.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.depositPaymentDescription'
        type='text'
        multiline={true}
        label={t('application.list.depositPaymentDescription')}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.creditStatus'
        label={t('application.list.creditStatus')}
        select
        required
      >
        {creditStatus.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.data.collateralDescription'
        type='text'
        multiline={true}
        label={t('application.list.collateralDescription')}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <Field
        fullWidth
        name='application.data.readyForMoveDate'
        type='text'
        required
        label={t('application.list.readyForMoveDate')}
        component={ReduxDatePicker}
        inputVariant='outlined'
      />
    </Grid>
    <Grid item xs={12}>
      <ReduxFormField
        name='application.data.notes'
        type='text'
        label={t('application.list.notes')}
        multiline={true}
      />
    </Grid>
    <Grid item xs={12} sm={4}>
      <ReduxFormField
        name='application.status'
        label={t('application.list.status')}
        select
        required
        validate={[required]}
      >
        {status.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {t(label)}
          </MenuItem>
        ))}
      </ReduxFormField>
    </Grid>
  </Grid>
)

export default ApplicationFormFields
